var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89798 5.17408V8.32758L5.73107 9.49447C5.52161 9.70395 5.52161 10.0436 5.73107 10.253C5.83583 10.3578 5.97306 10.4101 6.11038 10.4101C6.24764 10.4101 6.38493 10.3578 6.48968 10.253L7.81368 8.92904C7.91425 8.82846 7.97076 8.69201 7.97076 8.54976V5.17408C7.97076 4.87784 7.73062 4.6377 7.43437 4.6377C7.13812 4.6377 6.89798 4.87784 6.89798 5.17408Z",
    fill: "#FC854B",
    stroke: "#FC854B",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2273 3.94762C11.9788 1.98959 9.79842 0.768555 7.43426 0.768555C5.60034 0.768555 3.8762 1.48273 2.5794 2.77948C1.28266 4.07628 0.568481 5.80042 0.568481 7.63433C0.568481 9.46824 1.28266 11.1924 2.5794 12.4892C3.8762 13.7859 5.60034 14.5001 7.43426 14.5001C7.43879 14.5001 7.44316 14.4995 7.44767 14.4994C7.45217 14.4995 7.45654 14.5001 7.46108 14.5001C7.65439 14.5001 7.84961 14.492 8.04137 14.4759C8.33657 14.4512 8.55584 14.1918 8.53114 13.8966C8.50639 13.6014 8.24739 13.3821 7.95184 13.4069C7.78975 13.4204 7.62465 13.4273 7.46108 13.4273C7.45654 13.4273 7.45217 13.4279 7.44767 13.428C7.44316 13.4279 7.43879 13.4273 7.43426 13.4273C4.23998 13.4273 1.64126 10.8286 1.64126 7.63433C1.64126 4.44005 4.23998 1.84133 7.43426 1.84133C9.49286 1.84133 11.3863 2.9386 12.421 4.68419L12.4172 4.67779L13.2273 3.94762Z",
    fill: "#FC854B",
    stroke: "#FC854B",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0737 5.1192L13.3764 5.53583C13.7149 5.57853 14.031 5.33322 14.0737 4.99469L14.4904 1.69201C14.5331 1.35348 14.2878 1.03734 13.9492 0.994636C13.6107 0.951931 13.2946 1.19725 13.2519 1.53577L12.9133 4.2192L10.2299 3.88069C9.89139 3.83799 9.57525 4.0833 9.53254 4.42183C9.48984 4.76035 9.73515 5.07649 10.0737 5.1192Z",
    fill: "#FC854B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusHistory);
export default __webpack_public_path__ + "static/media/statusHistory.b3a04fb508b6ed7a2431ff5a8860ef12.svg";
export { ForwardRef as ReactComponent };